export const HOME_SECTIONS = [
    {
        key: "myOverdue",
        titleKey: "home.myOverdue",
        bodyKey: "home.myOverdueBody",
        clearKey: "home.myOverdueClear",
        /** **شغلُك تراه بلا قدرة** — كما في «شغلي» تماماً */
        capability: null,
        destination: "my-work",
        tone: "urgent",
    },
    {
        key: "awaitingReview",
        titleKey: "home.awaitingReview",
        bodyKey: "home.awaitingReviewBody",
        clearKey: "home.awaitingReviewClear",
        /** **«مستنّي مراجعتك» لمن يراجع** — وكانت لمن يطّلع، فتعدّ ما لا يملك قرارَه */
        capability: "plans.items.review",
        destination: "actions",
        actionKind: "plan_task.review",
        tone: "attention",
    },
    {
        key: "revisionExceptions",
        titleKey: "home.revisionExceptions",
        bodyKey: "home.revisionExceptionsBody",
        clearKey: "home.revisionExceptionsClear",
        capability: "plans.revision_exceptions.resolve",
        destination: "actions",
        actionKind: "plan_item.revision_exception",
        tone: "urgent",
    },
    {
        key: "dueChanges",
        titleKey: "home.dueChanges",
        bodyKey: "home.dueChangesBody",
        clearKey: "home.dueChangesClear",
        capability: "cards.due.change",
        destination: "actions",
        actionKind: "card.due_change",
        tone: "attention",
    },
    {
        key: "accessRequests",
        titleKey: "home.accessRequests",
        bodyKey: "home.accessRequestsBody",
        clearKey: "home.accessRequestsClear",
        capability: "access_requests.resolve",
        destination: "actions",
        actionKind: "access_request.resolve",
        tone: "attention",
    },
    {
        key: "storageAlerts",
        titleKey: "home.storageAlerts",
        bodyKey: "home.storageAlertsBody",
        clearKey: "home.storageAlertsClear",
        capability: "clients.storage.manage",
        destination: "clients",
        tone: "attention",
    },
];
export const HOME_SECTION_KEYS = HOME_SECTIONS.map((section) => section.key);
export function homeSection(key) {
    const found = HOME_SECTIONS.find((section) => section.key === key);
    if (!found)
        throw new Error(`home section not declared: ${key}`);
    return found;
}
//# sourceMappingURL=registry.js.map